import { makeStyles } from "@material-ui/core/styles"

const LIGHT_GRAY = "#cdcdcd"

export default makeStyles((theme) => ({
  container: {
    display: "flex"
  },
  headbandTitle: {
    alignItems: "center",
    textTransform: "uppercase",
    fontWeight: "600",
    fontSize: "14px",
    letterSpacing: "1px"
  },
  perfInfoBoxContainer: {
    display: "flex",
    color: "inherit"
  },
  perfInfoBox: {
    display: "flex",
    alignItems: "flex-end",
    backgroundColor: theme.palette.common.mainVariant2,
    padding: theme.spacing(1),
    margin: theme.spacing(1)
  },
  perfInfoBoxText: {
    fontWeight: 600,
    fontSize: "1.0rem",
    lineHeight: 1.334,
    letterSpacing: "0em"
  },
  perfInfoBoxCaption: {
    marginLeft: "6px",
    fontWeight: 400,
    fontSize: "0.8rem",
    lineHeight: 1.57,
    letterSpacing: "0.00714em"
  },
  perfInfoBoxGreen: {
    color: theme.palette.common.lightGreen
  },
  perfInfoBoxRed: {
    color: theme.palette.common.lightRose
  },
  menuContainer: {
    maxWidth: "380px",
    marginRight: theme.spacing(2)
  },
  menuSubTitle: {
    color: theme.palette.text.contrastText,
    backgroundColor: theme.palette.common.mainVariant1,
    textAlign: "center",
    padding: theme.spacing(1),
    marginBottom: theme.spacing(2),
    borderRadius: "2px"
  },
  menuBox: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  tabsMenuBox: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  textTitlePrimary: {
    fontWeight: "bold",
    fontSize: 12,
    color: theme.palette.primary.main
  },
  textTitle: {
    fontWeight: "bold",
    fontSize: 12,
    color: theme.palette.secondary.main
  },
  divider: {
    backgroundColor: LIGHT_GRAY,
    border: 0,
    height: 1,
    width: "100%",
    marginTop: 25,
    marginBottom: 25,
    justifySelf: "center"
  },
  tabIndicator: {
    left: 0
  },
  tabRow: {},
  tabItem: {
    width: "100%"
  },
  tabItemWrapper: {
    textAlign: "left",
    alignItems: "flex-start",
    justifyContent: "flex-start"
  },
  tabBorders: {
    borderBottom: `1px solid ${theme.palette.divider}`
  },
  selector: {
    width: "100%"
  },
  main: {
    flexGrow: 1
  },
  card: {
    marginBottom: theme.spacing(2)
  },
  cardContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: 0,
    maxHeight: "130px",
    height: "130px"
  },
  cardActions: {
    color: theme.palette.text.contrastText,
    backgroundColor: theme.palette.common.mainVariant1,
    padding: 0,
    textAlign: "center",
    textTransform: "uppercase",
    cursor: "pointer"
  },
  cardDetails: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.common.mainVariant3,
    borderTop: `1px solid ${theme.palette.common.white}`,
    display: "flex",
    flexDirection: "column"
  },
  cardDetailsBox: {
    padding: theme.spacing(2)
  },
  cardDetailsAvatar: {
    textAlign: "center"
  },
  cardDetailsText: {
    textAlign: "justify"
  },
  cardDetailsButton: {
    color: "white",
    textTransform: "uppercase",
    border: `2px solid white`,
    borderRadius: 0,
    marginRight: theme.spacing(1)
  },
  masterFundInfoBox: {
    padding: theme.spacing(2),
    minWidth: "36%",
    maxWidth: "36%"
  },
  fundsInfoBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(2),
    maxWidth: "140px",
    minWidth: "140px"
  },
  documentCard: {
    display: "flex",
    backgroundColor: "white",
    color: theme.palette.text.primary,
    borderRadius: "2px",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
    maxWidth: "320px",
    cursor: "pointer",
    "&:hover": {
      boxShadow:
        "0px 2px 4px -1px rgba(0,0,0,0.2)," +
        "0px 4px 5px 0px rgba(0,0,0,0.14)," +
        "0px 1px 10px 0px rgba(0,0,0,0.12)"
    }
  },
  documentLink: {
    fontStyle: "italic"
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7)
  },
  marginAuto: {
    margin: "auto"
  },
  fundPresentationTextTitle: {
    fontWeight: "bold",
    fontSize: 12,
    color: theme.palette.primary.main
  },
  fundPresentationText: {
    fontSize: 12
  },
  strongText: {
    textTransform: "uppercase",
    fontWeight: "600",
    fontSize: "14px",
    letterSpacing: "1px"
  }
}))
